import { useEffect, useState } from 'react';

import { Outlet } from 'react-router-dom';

import '@/shared/ui/admin-v2/admin-v2.css';

import { AdminSidebar } from './AdminSidebar';
import { AdminTopbar } from './AdminTopbar';

/**
 * Основной layout админки v2.
 */
export const AdminLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add('admin-v2-body');

    return () => {
      document.body.classList.remove('admin-v2-body');
    };
  }, []);

  return (
    <div className='app admin-v2-app'>
      <a className='skip-link' href='#admin-main-content'>
        К основному содержимому
      </a>
      <AdminSidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <main className='main' id='admin-main-content' tabIndex={-1}>
        <AdminTopbar onMenuClick={() => setMobileOpen(value => !value)} />
        <Outlet />
      </main>
    </div>
  );
};
